import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private cache: Record<string, any> = {};

  constructor() { }

  set(key: string, value: any) {
    this.cache[key] = value;
  }

  get<T>(key: string) {
    return this.cache[key] as T;
  }

  remove(key: string) {
    delete this.cache[key];
  }

  clear() {
    this.cache = {};
  }

  includes(key: string) {
    return key in this.cache;
  }
}